import { primaryColor } from 'styles'

export default {
  '.fm': {
    fontFamily: '"icons" !important',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '1rem',
    display: 'inline-block',
    textDecoration: 'inherit',
    textAlign: 'center',
    fontVariant: 'normal',
    textTransform: 'none',
    '-webkit-font-smoothing': 'antialiased',
    '-moz-osx-font-smoothing': 'grayscale',

    '&.-pointer': {
      cursor: 'pointer',

      '&:hover': {
        color: `${primaryColor} !important`,
      },
    },
  },

  '.fm.fm-oms:before': { content: "'\\e82e'" },
  '.fm.fm-returns:before': { content: "'\\e84b'" },
  '.fm.fm-shop:before': { content: "'\\e839'" },

  '.fm.fm-arrowup:before': { content: "'\\e83a'" },
  '.fm.fm-at:before': { content: "'\\e818'" },
  '.fm.fm-calendar:before': { content: "'\\e819'" },
  '.fm.fm-cart:before': { content: "'\\e81a'" },
  '.fm.fm-cart-ccc:before': { content: "'\\e81b'" },
  '.fm.fm-ccc-express:before': { content: "'\\e81c'" },
  '.fm.fm-closethin:before': { content: "'\\e81d'" },
  '.fm.fm-clubcard:before': { content: "'\\e81e'" },
  '.fm.fm-conversion:before': { content: "'\\e81f'" },
  '.fm.fm-conversion-alternative:before': { content: "'\\e829'" },
  '.fm.fm-database:before': { content: "'\\e820'" },
  '.fm.fm-dollar:before': { content: "'\\e821'" },
  '.fm.fm-dropdownlist:before': { content: "'\\e822'" },
  '.fm.fm-esize:before': { content: "'\\e823'" },
  '.fm.fm-filter:before': { content: "'\\e824'" },
  '.fm.fm-future-replenishment:before': { content: "'\\e825'" },
  '.fm.fm-header-table:before': { content: "'\\e826'" },
  '.fm.fm-home:before': { content: "'\\e827'" },
  '.fm.fm-info:before': { content: "'\\e828'" },
  '.fm.fm-instore:before': { content: "'\\e849'" },
  '.fm.fm-l4l:before': { content: "'\\e82a'" },
  '.fm.fm-languages:before': { content: "'\\e82b'" },
  '.fm.fm-lifting:before': { content: "'\\e82c'" },
  '.fm.fm-magnif:before': { content: "'\\e82d'" },
  '.fm.fm-margin:before': { content: "'\\e848'" },
  '.fm.fm-menu:before': { content: "'\\e82f'" },
  '.fm.fm-more:before': { content: "'\\e830'" },
  '.fm.fm-new-shop:before': { content: "'\\e831'" },
  '.fm.fm-order-checked:before': { content: "'\\e832'" },
  '.fm.fm-promotions:before': { content: "'\\e834'" },
  '.fm.fm-ranking:before': { content: "'\\e835'" },
  '.fm.fm-refresh:before': { content: "'\\e836'" },
  '.fm.fm-replenishment:before': { content: "'\\e837'" },
  '.fm.fm-screenrotate:before': { content: "'\\e838'" },
  '.fm.fm-surfchange-down:before': { content: "'\\e83c'" },
  '.fm.fm-surfchange-up:before': { content: "'\\e83d'" },
  '.fm.fm-surfchange:before': { content: "'\\e83b'" },
  '.fm.fm-temperature:before': { content: "'\\e83e'" },
  '.fm.fm-traffic:before': { content: "'\\e83f'" },
  '.fm.fm-phone:before': { content: "'\\e833'" },
  '.fm.fm-traffic-web:before': { content: "'\\e84c'" },
  '.fm.fm-returns-ecom:before': { content: "'\\e84d'" },
  '.fm.fm-returns-necom:before': { content: "'\\e84e'" },

  '.fm.fm-arrow-positive:before, .fm.fm-arrow-up:before': { content: "'\\e83a'" },
  '.fm.fm-arrow-negative:before, .fm.fm-arrow-down:before': { content: "'\\e83a'" },
  '.fm.fm-arrow-negative, .fm.fm-arrow-down': { transform: 'rotateX(180deg)' },

  '.fm.fm-wsymbol_0004_black_low_cloud:before': { content: "'\\e844'" },
  '.fm.fm-wsymbol_0008_clear_sky_night:before': { content: "'\\e847'" },
  '.fm.fm-wsymbol_0018_cloudy_with_heavy_rain:before': { content: "'\\e807'" },
  '.fm.fm-wsymbol_0034_cloudy_with_heavy_rain_night:before': { content: "'\\e813'" },
  '.fm.fm-wsymbol_0020_cloudy_with_heavy_snow:before': { content: "'\\e809'" },
  '.fm.fm-wsymbol_0036_cloudy_with_heavy_snow_night:before': { content: "'\\e815'" },
  '.fm.fm-wsymbol_0017_cloudy_with_light_rain:before': { content: "'\\e806'" },
  '.fm.fm-wsymbol_0033_cloudy_with_light_rain_night:before': { content: "'\\e812'" },
  '.fm.fm-wsymbol_0019_cloudy_with_light_snow:before': { content: "'\\e808'" },
  '.fm.fm-wsymbol_0035_cloudy_with_light_snow_night:before': { content: "'\\e814'" },
  '.fm.fm-wsymbol_0021_cloudy_with_sleet:before': { content: "'\\e80a'" },
  '.fm.fm-wsymbol_0037_cloudy_with_sleet_night:before': { content: "'\\e816'" },
  '.fm.fm-wsymbol_0007_fog:before': { content: "'\\e846'" },
  '.fm.fm-wsymbol_0010_heavy_rain_showers:before': { content: "'\\e801'" },
  '.fm.fm-wsymbol_0026_heavy_rain_showers_night:before': { content: "'\\e80d'" },
  '.fm.fm-wsymbol_0012_heavy_snow_showers:before': { content: "'\\e803'" },
  '.fm.fm-wsymbol_0028_heavy_snow_showers_night:before': { content: "'\\e80f'" },
  '.fm.fm-wsymbol_0009_light_rain_showers:before': { content: "'\\e800'" },
  '.fm.fm-wsymbol_0011_light_snow_showers:before': { content: "'\\e802'" },
  '.fm.fm-wsymbol_0027_light_snow_showers_night:before': { content: "'\\e80e'" },
  '.fm.fm-wsymbol_0025_light_rain_showers_night:before': { content: "'\\e80c'" },
  '.fm.fm-wsymbol_0006_mist:before': { content: "'\\e845'" },
  '.fm.fm-wsymbol_0013_sleet_showers:before': { content: "'\\e804'" },
  '.fm.fm-wsymbol_0029_sleet_showers_night:before': { content: "'\\e810'" },
  '.fm.fm-wsymbol_0001_sunny:before': { content: "'\\e841'" },
  '.fm.fm-wsymbol_0002_sunny_intervals:before': { content: "'\\e842'" },
  '.fm.fm-wsymbol_0024_thunderstorms:before': { content: "'\\e80b'" },
  '.fm.fm-wsymbol_0040_thunderstorms_night:before': { content: "'\\e817'" },
  '.fm.fm-wsymbol_0032_thundery_showers_night:before': { content: "'\\e811'" },
  '.fm.fm-wsymbol_0003_white_cloud:before': { content: "'\\e843'" },
  '.fm.fm-windy:before': { content: "'\\e840'" },
  '.fm.fm-wsymbol_0016_thundery_showers:before': { content: "'\\e805'" },
}
